export const US_STATES = [
  "AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC",
  "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY",
  "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE",
  "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK",
  "OR", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT",
  "VA", "VI", "WA", "WV", "WI", "WY",
];

export const STATE_NAME_TO_CODE = {
  "alabama": "AL", "alaska": "AK", "american samoa": "AS", "arizona": "AZ",
  "arkansas": "AR", "california": "CA", "colorado": "CO", "connecticut": "CT",
  "delaware": "DE", "district of columbia": "DC", "florida": "FL", "georgia": "GA",
  "guam": "GU", "hawaii": "HI", "idaho": "ID", "illinois": "IL", "indiana": "IN",
  "iowa": "IA", "kansas": "KS", "kentucky": "KY", "louisiana": "LA", "maine": "ME",
  "maryland": "MD", "massachusetts": "MA", "michigan": "MI", "minnesota": "MN",
  "mississippi": "MS", "missouri": "MO", "montana": "MT", "nebraska": "NE",
  "nevada": "NV", "new hampshire": "NH", "new jersey": "NJ", "new mexico": "NM",
  "new york": "NY", "north carolina": "NC", "north dakota": "ND",
  "northern mariana islands": "MP", "ohio": "OH", "oklahoma": "OK", "oregon": "OR",
  "pennsylvania": "PA", "puerto rico": "PR", "rhode island": "RI",
  "south carolina": "SC", "south dakota": "SD", "tennessee": "TN", "texas": "TX",
  "utah": "UT", "vermont": "VT", "virgin islands": "VI", "virginia": "VA",
  "washington": "WA", "west virginia": "WV", "wisconsin": "WI", "wyoming": "WY",
};

export function normalizeState(val) {
  if (!val) return "";
  const trimmed = val.trim();
  if (trimmed.length === 2) return trimmed.toUpperCase();
  return STATE_NAME_TO_CODE[trimmed.toLowerCase()] ?? trimmed;
}

export const CLAIM_PAYERS = [
  { stediId: "MNFSB", primaryPayerId: "10112", displayName: "Medicare Alabama Part B", state: "AL" },
  { stediId: "QXBAU", primaryPayerId: "02102", displayName: "Medicare Alaska Part B", state: "AK" },
  { stediId: "IKWOZ", primaryPayerId: "01212", displayName: "Medicare American Samoa Part B", state: "AS" },
  { stediId: "NXLKN", primaryPayerId: "03102", displayName: "Medicare Arizona Part B", state: "AZ" },
  { stediId: "CMNAM", primaryPayerId: "07102", displayName: "Medicare Arkansas Part B", state: "AR" },
  { stediId: "GRAQC", primaryPayerId: "01112", displayName: "Medicare Northern California Part B", state: "CA" },
  { stediId: "TXZWZ", primaryPayerId: "01182", displayName: "Medicare Southern California Part B", state: "CA" },
  { stediId: "XLJWK", primaryPayerId: "04112", displayName: "Medicare Colorado Part B", state: "CO" },
  { stediId: "NSFWX", primaryPayerId: "13102", displayName: "Medicare Connecticut Part B", state: "CT" },
  { stediId: "LZYHP", primaryPayerId: "00902", displayName: "Medicare Delaware Part B", state: "DE" },
  { stediId: "RTSOF", primaryPayerId: "SMDC0", displayName: "Medicare District of Columbia Part B", state: "DC" },
  { stediId: "CAUMJ", primaryPayerId: "09102", displayName: "Medicare Florida Part B", state: "FL" },
  { stediId: "UHKGD", primaryPayerId: "SMGA0", displayName: "Medicare Georgia Part B", state: "GA" },
  { stediId: "LPNBE", primaryPayerId: "02202", displayName: "Medicare Idaho Part B", state: "ID" },
  { stediId: "SRIZO", primaryPayerId: "06102", displayName: "Medicare Illinois Part B", state: "IL" },
  { stediId: "LQDAQ", primaryPayerId: "SMIN0", displayName: "Medicare Indiana Part B", state: "IN" },
  { stediId: "GFWMT", primaryPayerId: "SMIA0", displayName: "Medicare Iowa Part B", state: "IA" },
  { stediId: "IDLNG", primaryPayerId: "05202", displayName: "Medicare Kansas Part B", state: "KS" },
  { stediId: "CJGTG", primaryPayerId: "15102", displayName: "Medicare Kentucky Part B", state: "KY" },
  { stediId: "TIUDR", primaryPayerId: "07202", displayName: "Medicare Louisiana Part B", state: "LA" },
  { stediId: "OIAQK", primaryPayerId: "14112", displayName: "Medicare Maine Part B", state: "ME" },
  { stediId: "TPDAP", primaryPayerId: "SMMD0", displayName: "Medicare Maryland Part B", state: "MD" },
  { stediId: "UFMAP", primaryPayerId: "14212", displayName: "Medicare Massachusetts Part B", state: "MA" },
  { stediId: "VXUHI", primaryPayerId: "08202", displayName: "Medicare Michigan Part B", state: "MI" },
  { stediId: "KALXB", primaryPayerId: "06202", displayName: "Medicare Minnesota Part B", state: "MN" },
  { stediId: "QKTGS", primaryPayerId: "07302", displayName: "Medicare Mississippi Part B", state: "MS" },
  { stediId: "BJFUD", primaryPayerId: "05302", displayName: "Medicare Missouri Part B", state: "MO" },
  { stediId: "FVZBQ", primaryPayerId: "03202", displayName: "Medicare Montana Part B", state: "MT" },
  { stediId: "IAONR", primaryPayerId: "SMNE0", displayName: "Medicare Nebraska Part B", state: "NE" },
  { stediId: "MERIG", primaryPayerId: "01312", displayName: "Medicare Nevada Part B", state: "NV" },
  { stediId: "WVLKL", primaryPayerId: "14312", displayName: "Medicare New Hampshire Part B", state: "NH" },
  { stediId: "ICNFI", primaryPayerId: "12402", displayName: "Medicare New Jersey Part B", state: "NJ" },
  { stediId: "FRNPY", primaryPayerId: "04212", displayName: "Medicare New Mexico Part B", state: "NM" },
  { stediId: "LQOTI", primaryPayerId: "13282", displayName: "Medicare New York Part B Upstate", state: "NY" },
  { stediId: "XTAEG", primaryPayerId: "13292", displayName: "Medicare New York Part B Queens", state: "NY" },
  { stediId: "FIEWT", primaryPayerId: "11502", displayName: "Medicare North Carolina Part B", state: "NC" },
  { stediId: "QJIDK", primaryPayerId: "SMNC0", displayName: "Medicare North Carolina Part B", state: "NC" },
  { stediId: "BHTSB", primaryPayerId: "03302", displayName: "Medicare North Dakota Part B", state: "ND" },
  { stediId: "BCINK", primaryPayerId: "15202", displayName: "Medicare Ohio Part B", state: "OH" },
  { stediId: "AZMFS", primaryPayerId: "04312", displayName: "Medicare Oklahoma Part B", state: "OK" },
  { stediId: "KQRYC", primaryPayerId: "02302", displayName: "Medicare Oregon Part B", state: "OR" },
  { stediId: "WBHXR", primaryPayerId: "12502", displayName: "Medicare Pennsylvania Part B", state: "PA" },
  { stediId: "KXVQE", primaryPayerId: "SMPR0", displayName: "Medicare Puerto Rico Part B", state: "PR" },
  { stediId: "OXYGY", primaryPayerId: "14412", displayName: "Medicare Rhode Island Part B", state: "RI" },
  { stediId: "KIZWB", primaryPayerId: "SMSC0", displayName: "Medicare South Carolina Part B", state: "SC" },
  { stediId: "URZPH", primaryPayerId: "03402", displayName: "Medicare South Dakota Part B", state: "SD" },
  { stediId: "AMCKE", primaryPayerId: "SMTN0", displayName: "Medicare Tennessee Part B", state: "TN" },
  { stediId: "TPTWE", primaryPayerId: "04412", displayName: "Medicare Texas Part B", state: "TX" },
  { stediId: "VEHYM", primaryPayerId: "03502", displayName: "Medicare Utah Part B", state: "UT" },
  { stediId: "FQEQC", primaryPayerId: "14512", displayName: "Medicare Vermont Part B", state: "VT" },
  { stediId: "GDYAL", primaryPayerId: "09302", displayName: "Medicare Virgin Islands Part B", state: "VI" },
  { stediId: "PWITK", primaryPayerId: "11302", displayName: "Medicare Virginia Part B", state: "VA" },
  { stediId: "GYNUK", primaryPayerId: "02402", displayName: "Medicare Washington Part B", state: "WA" },
  { stediId: "DYOQK", primaryPayerId: "11402", displayName: "Medicare West Virginia Part B", state: "WV" },
  { stediId: "OJIZF", primaryPayerId: "06302", displayName: "Medicare Wisconsin Part B", state: "WI" },
  { stediId: "IQBSM", primaryPayerId: "03602", displayName: "Medicare Wyoming Part B", state: "WY" },
];

// CMS place-of-service codes accepted by Stedi. Keep in sync with util/placeofservice.go.
// Names checked against https://www.cms.gov/medicare/coding-billing/place-of-service-codes/code-sets (2026-09-24).
export const DEFAULT_PLACE_OF_SERVICE = "12";

const PLACE_OF_SERVICE_LABELS = [
  ["01", "Pharmacy"],
  ["02", "Telehealth Provided Other than in Patient's Home"],
  ["03", "School"],
  ["04", "Homeless Shelter"],
  ["05", "Indian Health Service Free-standing Facility"],
  ["06", "Indian Health Service Provider-based Facility"],
  ["07", "Tribal 638 Free-standing Facility"],
  ["08", "Tribal 638 Provider-based Facility"],
  ["09", "Prison/Correctional Facility"],
  ["10", "Telehealth Provided in Patient's Home"],
  ["11", "Office"],
  ["12", "Home"],
  ["13", "Assisted Living Facility"],
  ["14", "Group Home"],
  ["15", "Mobile Unit"],
  ["16", "Temporary Lodging"],
  ["17", "Walk-in Retail Health Clinic"],
  ["18", "Place of Employment-Worksite"],
  ["19", "Off Campus-Outpatient Hospital"],
  ["20", "Urgent Care Facility"],
  ["21", "Inpatient Hospital"],
  ["22", "On Campus-Outpatient Hospital"],
  ["23", "Emergency Room – Hospital"],
  ["24", "Ambulatory Surgical Center"],
  ["25", "Birthing Center"],
  ["26", "Military Treatment Facility"],
  ["27", "Outreach Site/Street"],
  ["31", "Skilled Nursing Facility"],
  ["32", "Nursing Facility"],
  ["33", "Custodial Care Facility"],
  ["34", "Hospice"],
  ["41", "Ambulance - Land"],
  ["42", "Ambulance – Air or Water"],
  ["49", "Independent Clinic"],
  ["50", "Federally Qualified Health Center"],
  ["51", "Inpatient Psychiatric Facility"],
  ["52", "Psychiatric Facility-Partial Hospitalization"],
  ["53", "Community Mental Health Center"],
  ["54", "Intermediate Care Facility/Individuals with Intellectual Disabilities"],
  ["55", "Residential Substance Abuse Treatment Facility"],
  ["56", "Psychiatric Residential Treatment Center"],
  ["57", "Non-residential Substance Abuse Treatment Facility"],
  ["58", "Non-residential Opioid Treatment Facility"],
  ["60", "Mass Immunization Center"],
  ["61", "Comprehensive Inpatient Rehabilitation Facility"],
  ["62", "Comprehensive Outpatient Rehabilitation Facility"],
  ["65", "End-Stage Renal Disease Treatment Facility"],
  ["66", "Programs of All-Inclusive Care for the Elderly (PACE) Center"],
  ["71", "Public Health Clinic"],
  ["72", "Rural Health Clinic"],
  ["81", "Independent Laboratory"],
  ["99", "Other Place of Service"],
];

export const PLACE_OF_SERVICE_OPTIONS = PLACE_OF_SERVICE_LABELS.map(([value, name]) => ({
  value,
  label: `${value} - ${name}`,
}));